import { X } from "lucide-react";
import type { ComponentType } from "react";
import type { SharedToolbarBadgeProps } from "./toolbar_types";

export type ServiceLike = { id: number; label: string };

export type CityLike = { id: number; name: string };

export const FILTER_BADGE_REMOVE_ICON_CLASS =
  "h-3 w-3 cursor-pointer hover:text-red-500";

export type FilterSelectionBadgeLabels = {
  badgeLanguagePrefix: string;
  badgeServicePrefix: string;
  badgeCityPrefix: string;
};

export type FilterSelectionBadgesProps<
  TService extends ServiceLike,
  TCity extends CityLike,
> = {
  labels: FilterSelectionBadgeLabels;
  getLanguageDisplayLabel: (code: string) => string;
  selectedLanguages: string[];
  selectedServices: TService[];
  selectedCities: TCity[];
  onRemoveLanguage: (code: string) => void | Promise<void>;
  onRemoveService: (id: number) => void | Promise<void>;
  onRemoveCity: (id: number) => void | Promise<void>;
  Badge: ComponentType<SharedToolbarBadgeProps>;
};

/** Language, service, and city chips only (no wrapper — parent supplies flex/grid). */
export function FilterSelectionBadges<
  TService extends ServiceLike,
  TCity extends CityLike,
>({
  labels,
  getLanguageDisplayLabel,
  selectedLanguages,
  selectedServices,
  selectedCities,
  onRemoveLanguage,
  onRemoveService,
  onRemoveCity,
  Badge,
}: FilterSelectionBadgesProps<TService, TCity>) {
  return (
    <>
      {selectedLanguages.map((lang) => (
        <Badge
          key={`lang-${lang}`}
          variant="light"
          color="light"
          size="md"
          endIcon={
            <X
              className={FILTER_BADGE_REMOVE_ICON_CLASS}
              onClick={() => {
                void onRemoveLanguage(lang);
              }}
            />
          }
        >
          {labels.badgeLanguagePrefix}: {getLanguageDisplayLabel(lang)}
        </Badge>
      ))}
      {selectedServices.map((service) => (
        <Badge
          key={`service-${service.id}`}
          variant="light"
          color="light"
          size="md"
          endIcon={
            <X
              className={FILTER_BADGE_REMOVE_ICON_CLASS}
              onClick={() => {
                void onRemoveService(service.id);
              }}
            />
          }
        >
          {labels.badgeServicePrefix}: {service.label}
        </Badge>
      ))}
      {selectedCities.map((city) => (
        <Badge
          key={`city-${city.id}`}
          variant="light"
          color="light"
          size="md"
          endIcon={
            <X
              className={FILTER_BADGE_REMOVE_ICON_CLASS}
              onClick={() => {
                void onRemoveCity(city.id);
              }}
            />
          }
        >
          {labels.badgeCityPrefix}: {city.name}
        </Badge>
      ))}
    </>
  );
}
